/* eslint-disable no-alert */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import moment from 'moment';

import { del } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';

function Routes(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
    timeOut: 8000,
  };

  const { t } = props;

  const [signal, setSignal] = useState(0);

  const deleteRoute = async (route) => {
    try {
      await del(`/api/warehouse/putaway/route/${route.id}`);

      toastr.success(t('Route deleted successfully'));
      setSignal(signal + 1);
    } catch (error) {
      toastr.error(error.message, t('Could not delete route.'));
    }
  };

  useEffect(() => {
    setSignal(0);
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">
                  <span className="mdi mdi-map-marker-distance fs-5" />
                  {' '}
                  {t('Put-Away Routes')}
                </CardTitle>

                <Can i="see" this="putaway">
                  <BaseGrid
                    url="/api/warehouse/putaway/routes"
                    shouldUpdate={signal}
                    hasSearch
                    config={
                      {
                        columns: {
                          id: {
                            label: 'ID',
                            sort: true,
                            link: {
                              to: '/put-away/route/%id%',
                            },
                          },
                          created_by: {
                            label: t('Created By'),
                          },
                          created_at: {
                            label: 'Created',
                            date: {
                              format: (date) => (moment(date).fromNow()),
                              timezone: process.env.REACT_APP_LOCAL_TZ,
                            },
                            sort: true,
                          },
                          stops: {
                            label: t('Stops'),
                            format: (x) => x.length,
                          },
                          completed_at: {
                            label: 'Finished',
                            date: {
                              format: (date) => (moment(date).fromNow()),
                              timezone: process.env.REACT_APP_LOCAL_TZ,
                            },
                            sort: true,
                          },
                          progress: {
                            label: t('Progress'),
                            progress: {
                              value: (route) => {
                                if (route.stops.length === 0) return 0;
                                return (route.stops.filter(
                                  (stop) => stop.completed_at !== null,
                                ).length / route.stops.length) * 100;
                              },
                              color: (route) => (route.completed_at !== null ? 'success' : 'primary'),
                            },
                          },
                          note: {
                            label: t('Notes'),
                          },
                          actions: {
                            label: 'Actions',
                            actions: [
                              {
                                key: 'remove_route',
                                icon: 'mdi mdi-close-thick',
                                class: 'btn btn-sm btn-soft-danger text-dark',
                                alt: 'Delete Route',
                                click: deleteRoute,
                              },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 30,
                        },
                      }
                    }
                  />
                </Can>

                <Can not i="see" this="putaway"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Routes.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Routes));
